declare namespace $ {

	type $mol_locale_select__dictionary_exso_sheets_app_1 = $mol_type_enforce<
		({ 
			'ru': string,
			'kk': string,
		}) 
		,
		ReturnType< $mol_locale_select['dictionary'] >
	>
	type $mol_button_minor__click_exso_sheets_app_2 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['back_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_exso_sheets_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_exso_sheets_app_4 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['update'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_exso_sheets_app_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_exso_sheets_app_6 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['type_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_exso_sheets_app_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_exso_sheets_app_8 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['type_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_exso_sheets_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_date__value_exso_sheets_app_10 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['date'] >
		,
		ReturnType< $mol_date['value'] >
	>
	type $mol_date__trigger_content_exso_sheets_app_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_date['trigger_content'] >
	>
	type $mol_date__Clear_exso_sheets_app_12 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_date['Clear'] >
	>
	type $exso_sheets_site__title_content_exso_sheets_app_13 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['title_content'] >
		,
		ReturnType< $exso_sheets_site['title_content'] >
	>
	type $exso_sheets_site__all_shifts_exso_sheets_app_14 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['shifts'] >
		,
		ReturnType< $exso_sheets_site['all_shifts'] >
	>
	type $exso_sheets_site__all_blowings_exso_sheets_app_15 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['blowings'] >
		,
		ReturnType< $exso_sheets_site['all_blowings'] >
	>
	type $exso_sheets_site__site_arg_exso_sheets_app_16 = $mol_type_enforce<
		Record<string, any>
		,
		ReturnType< $exso_sheets_site['site_arg'] >
	>
	type $exso_sheets_site__tools_exso_sheets_app_17 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['tools'] >
		,
		ReturnType< $exso_sheets_site['tools'] >
	>
	type $exso_sheets_site__foot_exso_sheets_app_18 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['menu_foot'] >
		,
		ReturnType< $exso_sheets_site['foot'] >
	>
	type $exso_sheets_site__device_arg_exso_sheets_app_19 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['device_arg'] >
		,
		ReturnType< $exso_sheets_site['device_arg'] >
	>
	type $exso_sheets_device__foot_exso_sheets_app_20 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['menu_foot'] >
		,
		ReturnType< $exso_sheets_device['foot'] >
	>
	type $exso_sheets_device__tools_exso_sheets_app_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $exso_sheets_device['tools'] >
	>
	type $exso_sheets_device__title_content_exso_sheets_app_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $exso_sheets_device['title_content'] >
	>
	type $exso_sheets_device__all_shifts_exso_sheets_app_23 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['shifts'] >
		,
		ReturnType< $exso_sheets_device['all_shifts'] >
	>
	type $exso_sheets_dashboard__foot_exso_sheets_app_24 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['menu_foot'] >
		,
		ReturnType< $exso_sheets_dashboard['foot'] >
	>
	type $exso_sheets_dashboard__tools_exso_sheets_app_25 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['tools'] >
		,
		ReturnType< $exso_sheets_dashboard['tools'] >
	>
	type $exso_sheets_dashboard__title_exso_sheets_app_26 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['dashboard_title'] >
		,
		ReturnType< $exso_sheets_dashboard['title'] >
	>
	type $exso_sheets_dashboard__shifts_exso_sheets_app_27 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['dashboard_shifts'] >
		,
		ReturnType< $exso_sheets_dashboard['shifts'] >
	>
	type $exso_sheets_dashboard__slice_shifts_exso_sheets_app_28 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['slice_shifts'] >
		,
		ReturnType< $exso_sheets_dashboard['slice_shifts'] >
	>
	type $exso_sheets_dashboard__plans_exso_sheets_app_29 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['plans'] >
		,
		ReturnType< $exso_sheets_dashboard['plans'] >
	>
	type $exso_sheets_dashboard__month_shifts_exso_sheets_app_30 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['dashboard_shifts'] >
		,
		ReturnType< $exso_sheets_dashboard['month_shifts'] >
	>
	type $exso_sheets_dashboard__blowings_exso_sheets_app_31 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['blowings'] >
		,
		ReturnType< $exso_sheets_dashboard['blowings'] >
	>
	type $exso_sheets_dashboard__date_moment_exso_sheets_app_32 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['date_moment'] >
		,
		ReturnType< $exso_sheets_dashboard['date_moment'] >
	>
	type $exso_sheets_dashboard__site_arg_exso_sheets_app_33 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['site_arg'] >
		,
		ReturnType< $exso_sheets_dashboard['site_arg'] >
	>
	type $exso_sheets_login__login_exso_sheets_app_34 = $mol_type_enforce<
		ReturnType< $exso_sheets_app['login'] >
		,
		ReturnType< $exso_sheets_login['login'] >
	>
	export class $exso_sheets_app extends $mol_book2_catalog {
		Theme( ): $mol_theme_auto
		type( ): string
		Lang( ): $mol_locale_select
		Lights( ): $mol_lights_toggle
		login( next?: any ): any
		back_click( ): any
		Back_icon( ): $mol_icon_arrow_left
		Back( ): $mol_button_minor
		page_title( id: any): string
		title_content( ): readonly(any)[]
		update( ): any
		Update_icon( ): $mol_icon_reload
		Update( ): $mol_button_minor
		type_click( id: any): any
		Month( ): $mol_button_minor
		Day( ): $mol_button_minor
		default_date( ): string
		date( next?: ReturnType< $exso_sheets_app['default_date'] > ): ReturnType< $exso_sheets_app['default_date'] >
		date_moment( ): ReturnType< ReturnType< $exso_sheets_app['Date'] >['value_moment'] >
		date_format( ): string
		Date( ): $mol_date
		tools( ): readonly(any)[]
		id( id: any): string
		device_arg( id: any): ({ 
			'device': ReturnType< $exso_sheets_app['id'] >,
		})  & ReturnType< $exso_sheets_app['arg'] >
		Site( ): $exso_sheets_site
		shifts( id: any): readonly($exso_sheets_shift)[]
		Device( ): $exso_sheets_device
		dashboard_title( ): string
		dashboard_shifts( id: any): ReturnType< $exso_sheets_app['shifts'] >
		slice_shifts( ): ReturnType< $exso_sheets_app['shifts'] >
		plans( ): readonly($exso_sheets_plan)[]
		blowings( id: any): readonly($exso_sheets_blowing)[]
		site_arg( id: any): ({ 
			'site': ReturnType< $exso_sheets_app['id'] >,
			'type': any,
		})  & ReturnType< $exso_sheets_app['arg'] >
		Dashboard( ): $exso_sheets_dashboard
		favicon( ): $exso_logo_favicon
		title( ): string
		plugins( ): readonly(any)[]
		attr( ): ({ 
			'exso_sheets_app': ReturnType< $exso_sheets_app['type'] >,
		})  & ReturnType< $mol_book2_catalog['attr'] >
		ignored_spreads( ): readonly(any)[]
		Menu( ): any
		menu_foot( ): readonly(any)[]
		Placeholder( ): any
		user( next?: any ): any
		Login( ): $exso_sheets_login
		spreads( ): ({ 
			'site': ReturnType< $exso_sheets_app['Site'] >,
			'device': ReturnType< $exso_sheets_app['Device'] >,
			'': ReturnType< $exso_sheets_app['Dashboard'] >,
		}) 
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map